import { Request } from "@/utils";
import config from "@/configs";
import { pool_uuid } from "@/config.json";

//代理列表
export async function getAgentList(data) {
  return Request.post(config.getAgentList, data);
}

//收益展示
export async function getProfit() {
  return Request.get(config.getProfit);
}

//修改代理设置
export async function editAgent(data) {
  return Request.post(config.editAgent, data);
}

// 算力理论收益
export async function getDayEarn(params) {
  return Request.get(config.getDayEarn, { params });
}

// 创建代理
export async function addUser(data) {
  return Request.post(config.addUser, { ...data, pool_uuid });
}
